import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { wz } from '../../components/wizard-tokens';
import { WizAddChip, WizChip, WizInlineInput } from '../../components/wizard-ui';

interface Props {
  title: string;
  hint: string;
  items: string[];
  variant: 'blue' | 'grey' | 'red';
  onAdd: (text: string) => void;
  onRemove: (index: number) => void;
}

/** Eine der drei Kriterienspalten (Muss / Wünschenswert / Ausschluss). Enter übernimmt und schließt, Escape bricht ab, Blur übernimmt. */
const CriteriaColumn: React.FC<Props> = ({ title, hint, items, variant, onAdd, onRemove }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const [adding, setAdding] = useState(false);
  const [draft, setDraft] = useState('');

  const commit = (text: string) => {
    if (text.trim()) onAdd(text);
    setDraft('');
    setAdding(false);
  };

  return (
    <div className={classes.column}>
      <div className={classes.head}>
        <div className={classes.title}>{title}</div>
        <div className={classes.hint}>{hint}</div>
      </div>
      <div className={classes.chips}>
        {items.map((item, i) => (
          <WizChip key={`${item}-${i}`} variant={variant} onRemove={() => onRemove(i)}>
            {item}
          </WizChip>
        ))}
        {adding ? (
          <WizInlineInput
            value={draft}
            placeholder={t('wizJudgCriterionPlaceholder')}
            width={170}
            onChange={setDraft}
            onEnter={commit}
            onEscape={() => {
              setDraft('');
              setAdding(false);
            }}
            onBlur={commit}
          />
        ) : (
          <WizAddChip label={t('wizJudgAddCriterion')} onClick={() => setAdding(true)} />
        )}
      </div>
    </div>
  );
};

const useStyles = makeStyles()({
  column: {
    border: `1px solid ${wz.border}`,
    borderRadius: 10,
    padding: 14,
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  head: { display: 'flex', flexDirection: 'column', gap: 2 },
  title: { fontSize: 15, fontWeight: 700 },
  hint: { fontSize: 12, color: wz.muted },
  chips: { display: 'flex', flexWrap: 'wrap', gap: 6 },
});

export default CriteriaColumn;
